export const DEPARTMENT_LIST_REQUEST = "DEPARTMENT_LIST_REQUEST"; 
export const DEPARTMENT_LIST_SUCCESS = "DEPARTMENT_LIST_REQUEST_SUCCESS";
export const DEPARTMENT_CREATE_REQUEST = "DEPARTMENT_CREATE_REQUEST"; 
export const DEPARTMENT_DETAIL_REQUEST = "DEPARTMENT_DETAIL_REQUEST"; 
export const DEPARTMENT_ARCHIVE_REQUEST = "DEPARTMENT_ARCHIVE_REQUEST"; 
export const DEPARTMENT_DELETE_REQUEST = "DEPARTMENT_DELETE_REQUEST"; 
export const DEPARTMENT_UNARCHIVE_REQUEST = "DEPARTMENT_UNARCHIVE_REQUEST"; 
export const DEPARTMENT_EDIT_REQUEST = "DEPARTMENT_EDIT_REQUEST"; 
export const DEPARTMENT_CREATE_FORM_NAME = "createDepartment"; 
export const DEPARTMENT_EDIT_FORM_NAME = "editDepartment"; 
export const DEPARTMENT_AUTOCOMPLETE_REQUEST = "DEPARTMENT_AUTOCOMPLETE_REQUEST";
export const DEPARTMENT_AUTOCOMPLETE_SUCCESS = "DEPARTMENT_AUTOCOMPLETE_SUCCESS";
export const DEPARTMENT_SUBMIT_RULES = {
  name: {
    required: true
  },
  status: {
    required: true
  },
  morningIn: {
    required: true
  },
  morningOut: {
    required: true
  },
  afternoonIn: {
    required: true
  },
  afternoonOut: {
    required: true
  },
  breakTime: {
    required: true
  },
  code: {
    required: true
  },
  numberOfBreakingTimeLimit: {
    required: true
  }
};
export const DEPARTMENT_STATUS = [
  {
    id: 1,
    name: "Active",
  },
  {
    id: -1,
    name: "Deactive",
  },
];
export const READ_DEPARTMENT = 138000;
export const CREATE_DEPARTMENT = 138001;
export const UPDATE_DEPARTMENT = 138002;
export const DELETE_DEPARTMENT = 138003;
export const ARCHIVE_DEPARTMENT = 138004;
export const UNARCHIVE_DEPARTMENT = 138005;